import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m5 5 14 14", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M13 13a3 3 0 1 0 0-6H9v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9 17v-2.34", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ParkingCircleOff";
const ParkingCircleOff = memo(themed(Icon));
export {
  ParkingCircleOff
};
//# sourceMappingURL=parking-circle-off.js.map
